import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchInspectionTemplates, duplicateTemplate } from "../Reducers/actions";

const TemplatesPage = () => {
  const dispatch = useDispatch();
  const { inspectionTemplates, loading } = useSelector(state => state.zwembadinspecties);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    dispatch(fetchInspectionTemplates());
  }, [dispatch]);

  const handleDuplicate = (id) => {
    if (window.confirm("Wil je deze template dupliceren?")) {
      dispatch(duplicateTemplate(id));
    }
  };

  const filteredTemplates = filter === "all"
    ? inspectionTemplates
    : inspectionTemplates.filter(t => t.category === filter);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3>Inspectie Sjablonen</h3>
              <Link to="/zwembadinspecties/templates/nieuw" className="btn btn-primary">
                <i className="fas fa-plus"></i> Nieuw Sjabloon
              </Link>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-4">
                  <select
                    className="form-control"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="all">Alle categorieën</option>
                    <option value="veiligheid">Veiligheid</option>
                    <option value="hygiëne">Hygiëne</option>
                    <option value="technisch">Technisch</option>
                    <option value="algemeen">Algemeen</option>
                    <option value="legionella">Legionella</option>
                    <option value="chemisch">Chemisch</option>
                  </select>
                </div>
              </div>

              {loading ? (
                <div className="text-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Laden...</span>
                  </div>
                </div>
              ) : (
                <div className="row">
                  {filteredTemplates.length === 0 ? (
                    <div className="col-12">
                      <p className="text-center">Geen templates gevonden</p>
                    </div>
                  ) : (
                    filteredTemplates.map((template) => (
                      <div key={template._id} className="col-md-4 mb-3">
                        <div className="card h-100">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <h5 className="card-title">{template.name}</h5>
                              {template.is_default && (
                                <span className="badge badge-primary">Standaard</span>
                              )}
                            </div>
                            <p className="card-text text-muted small">{template.description}</p>
                            <div className="mb-2">
                              <span className="badge badge-info">{template.category}</span>
                              <span className="badge badge-secondary ml-2">v{template.version}</span>
                            </div>
                          </div>
                          <div className="card-footer bg-white">
                            <div className="btn-group w-100" role="group">
                              <Link
                                to={`/zwembadinspecties/templates/builder/${template._id}`}
                                className="btn btn-sm btn-outline-primary"
                              >
                                <i className="fas fa-edit"></i> Bewerk
                              </Link>
                              <button
                                onClick={() => handleDuplicate(template._id)}
                                className="btn btn-sm btn-outline-secondary"
                              >
                                <i className="fas fa-copy"></i> Dupliceer
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatesPage;
